module.exports = __webpack_public_path__ + "static/media/RG_110.3b117b18.png";